import { Link } from "react-router-dom";
import { ArrowUpRight, Play, Headphones, Youtube, Mic } from "lucide-react";
import { ASSISTART } from "@/data/content";

export default function Assistart() {
  return (
    <div data-testid="page-assistart" className="pt-28">
      {/* HERO */}
      <section className="relative min-h-[80vh] flex items-end overflow-hidden">
        <div className="absolute inset-0 -z-10">
          <img src={ASSISTART.cover} alt="Assistart" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A1F2E] via-[#0A1F2E]/85 to-[#0A1F2E]/60" />
        </div>
        <div className="container-x py-24 grid md:grid-cols-12 gap-10 text-white">
          <div className="md:col-span-8">
            <span className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.32em] font-semibold text-[#89E877]">
              <Mic className="h-3.5 w-3.5" /> Podcast & Video · a cura di XL Brokers
            </span>
            <h1 className="mt-6 font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.03] tracking-tight">
              Assistart.<br />
              <span className="italic text-[#89E877]">{ASSISTART.claim}</span>
            </h1>
            <p className="mt-8 max-w-2xl text-lg text-white/75 leading-relaxed">{ASSISTART.intro}</p>

            <div className="mt-10 flex flex-wrap gap-4">
              <a
                href={ASSISTART.spotifyUrl}
                target="_blank"
                rel="noreferrer"
                data-testid="assistart-spotify-cta"
                className="inline-flex items-center gap-3 bg-[#1DB954] text-black px-7 py-4 text-sm font-medium tracking-wide hover:bg-[#1ed760] transition-colors"
              >
                <Headphones className="h-4 w-4" /> Ascolta su Spotify
              </a>
              <a
                href={ASSISTART.youtubeUrl}
                target="_blank"
                rel="noreferrer"
                data-testid="assistart-youtube-cta"
                className="inline-flex items-center gap-3 bg-[#FF0000] text-white px-7 py-4 text-sm font-medium tracking-wide hover:bg-[#e60000] transition-colors"
              >
                <Youtube className="h-4 w-4" /> Guarda su YouTube
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* EPISODI */}
      <section className="section-y container-x">
        <div className="grid md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-6">
            <span className="overline">Episodi</span>
            <h2 className="mt-4 font-display text-4xl sm:text-5xl leading-tight">Le puntate più ascoltate.</h2>
          </div>
          <p className="md:col-span-6 md:justify-self-end max-w-md text-muted-foreground">
            Ogni due settimane un nuovo episodio. Racconti chiari, casi reali, ospiti dal mondo assicurativo e imprenditoriale italiano.
          </p>
        </div>

        <ul className="mt-16 divide-y divide-foreground/10 border-t border-b border-foreground/10">
          {ASSISTART.episodes.map((e) => (
            <li key={e.n}>
              <a
                href={e.url || ASSISTART.spotifyUrl}
                target="_blank"
                rel="noreferrer"
                data-testid={`assistart-episode-${e.n}`}
                className="grid grid-cols-12 gap-4 py-8 items-center group"
              >
                <span className="col-span-2 sm:col-span-1 font-display text-3xl text-primary/40 tabular-nums">
                  #{e.n}
                </span>
                <div className="col-span-8 sm:col-span-9">
                  <p className="font-display text-2xl sm:text-3xl group-hover:text-primary transition-colors">{e.title}</p>
                  <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{e.desc}</p>
                </div>
                <div className="col-span-2 flex justify-end">
                  <span className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-foreground text-background group-hover:bg-primary transition-colors">
                    <Play className="h-4 w-4 fill-current" />
                  </span>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </section>

      {/* CTA CROSS-LINK */}
      <section className="bg-[#0A1F2E] text-white section-y">
        <div className="container-x grid md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-8">
            <span className="overline text-[#89E877]">Consulenza</span>
            <h2 className="mt-4 font-display text-4xl sm:text-5xl leading-tight">
              Dopo aver ascoltato,<br />parliamone di persona.
            </h2>
            <p className="mt-6 text-white/70 text-lg max-w-xl">
              Se un episodio ti ha aperto una domanda sulla tua situazione assicurativa, scrivici. Un consulente XL Brokers ti richiama entro 24 ore.
            </p>
          </div>
          <div className="md:col-span-4 md:justify-self-end">
            <Link to="/contatti" data-testid="assistart-cta-contatti" className="inline-flex items-center gap-2 bg-white text-[#0A1F2E] px-8 py-4 text-sm font-medium tracking-wide hover:bg-[#89E877] transition-colors">
              Prenota una consulenza <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
